import { PageNotFoundComponent } from './system-common/page-not-found/page-not-found.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router'; // CLI imports router
import { LoginComponent } from './system-common/login/login.component';
import { SettingService } from './system-common/services/setting.service';

const routes: Routes = [
  // { path: 'login', component: LoginComponent },
  // { path: 'page-not-found', component: PageNotFoundComponent },
  // { path: '**', component: PageNotFoundComponent },
  // { path: '', redirectTo: '/page-not-found', pathMatch: 'full' },

  { path: 'login', component: LoginComponent },
  { path: 'page-not-found', component: PageNotFoundComponent },
  { path: '**', component: LoginComponent },
  { path: '', redirectTo: '/page-not-found', pathMatch: 'full' },

  // { path: '**', component: LoginComponent}, //Need to add loader
]; // sets up routes constant where you define your routes

// configures NgModule imports and exports
@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
